// import { InfoPerCADOfficeList } from './../models/contract-info';
import { DataService } from './data.service';
import { registerLocaleData } from '@angular/common';
import { LocalStorageService } from '../../core/services/local-storage.service';
import {
    ActionCallbackConfig,
    APPLICATION_STATUS,
    DataTableConfig,
    DATA_TABLE_CELL_TYPE,
    TRANSER_TYPE,
    DATA_TABLE_DETAIL_TYPE,
    DOCUMENT_STATUS,
    DOCUMENT_TITLE,
    DOCUMENT_VALIDITY,
    InfoTableConfig,
    InfoTableData,
    SELECT_TABLE_ROW_STATUS,
    TRANSACTION_INVITATION_STATUS,
    UserInfo,
    USER_CAPACITY,
    USER_ROLE,
    DOCUMENT_PUBLIC_SECTOR_OWNER,
    ContractingPeopleDetails,
} from '../../shared/shared.interface';

export function mapRequestSummary(
    response,
    config,
    taxNumber,
    allTexts
): InfoTableConfig {
    console.log();
    let tempRequestSummary;

    const citizenRole = response.involvedParties.find(
      (person) => person.vatId === taxNumber
    )?.role;
    let citizenCategory = '';
    if(citizenRole)
      citizenCategory = allTexts[citizenRole];

    tempRequestSummary = {
        infoTableBackground: config,
        infoTableData: [
            {
                headers: [
                    {
                        requestNumber: 'Κωδικός Αιτήματος',
                        // propertyAddress: 'Διεύθυνση Ακινήτου',
                        citizenCategory: 'Ιδιότητα Πολίτη',
                        notaryAfm: 'ΑΦΜ Συμβολαιογράφου',
                        notaryName: 'Ονοματεπώνυμο Συμβολαιογράφου',
                        submissionDate: 'Ημερομηνία Υποβολής',
                    },
                ],
                data: [
                    {
                        requestNumber: response.id,
                        // propertyAddress: response.addressEstate,
                        citizenCategory: citizenCategory,
                        notaryAfm: response.notaryVatId,
                        notaryName: response.notaryFullname,
                        submissionDate: dateFormat(response.submissionDate),
                    },
                ],
            },
        ],
    };

    return tempRequestSummary;
}

export function mapContractingPeopleTransactionAcceptance(response, taxNumber, role = null) {
    const notary = response.approvalViewInformation.find(
        (person) => person.role === 'NOTARY'
    );

    const userIndex = response.approvalViewInformation.findIndex(
        (person) => person.taxNumber === taxNumber && (role == null || person.role === role)
    );
    const tempAcceptance = {
        notary: {
            afm: notary.taxNumber,
            fullname: notary.fullname,
        },
        buyers: [],
        sellers: [],
        userCapacity: response.approvalViewInformation.splice(userIndex, 1)[0]
            .role,
        property: {
            address: response.addressEstate,
            atak: response.atakNumber,
        },
    };

    response.approvalViewInformation.map((person) => {
        const tempPerson = {
            fullname: person.fullname,
            afm: person.taxNumber,
            involvedProperties: person.involvedProperties,
        };

        if (person.role === 'BUYER') {
            tempAcceptance.buyers.push(tempPerson);
        } else if (person.role === 'SELLER') {
            tempAcceptance.sellers.push(tempPerson);
        }
    });

    return { ...tempAcceptance };
}

export function getValueOfDocument(
    documentData: any,
    key: string,
    docType: string
) {
    if (key === 'ownsNonSalarianFlg') {
        return labelMapper(documentData[key].toString(), docType);
    } else if (key === 'webCertWitDebitDetails') {
        return documentData[key]['subComments'];
    } else {
        return documentData[key];
    }
}

export function mapDocuments(
    response,
    appId?,
    actionCallbackConfigs?: ActionCallbackConfig[]
) {
    let documents = [];

    response.documents.map((document) => {
        const tempDoc = {
            documentId: {
                type: DATA_TABLE_CELL_TYPE.NOT_SHOWN,
                value: document.documentId,
            },
            documentTitle: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapDocumentTitle(document.documentType),
            },
            documentValidityDuration: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapDocumentDuration(
                    document.documentType,
                    document.documentExpirationInDays
                ),
            },
            documentStatus: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapDocumentStatus(document.documentState),
            },
            warning: {
                type: DATA_TABLE_CELL_TYPE.WARNING,
                value: mapDocumentPendingCitizenAction(document),
            },
            action: {
                type: DATA_TABLE_CELL_TYPE.ACTION,
                value: mapActions(document, appId, actionCallbackConfigs),
            },
            rowDetails: null,
        };

        if (
            document.documentType === 'PROOF_OF_PAYMENT' &&
            (document.documentState === 'READY' ||
                document.documentState === 'APPROVED')
        ) {
            tempDoc.documentStatus.value = 'Έχει ανακτηθεί';
        }

        if (document.documentType === 'DIAGRAM_REPORT') {
            tempDoc.rowDetails = {
                type: DATA_TABLE_DETAIL_TYPE.INPUT_FIELD,
                templateNumber: '0',
                desc: 'Tοπογραφικό διάγραμμα βάσει του υπό μεταβιβαζόμενου ακινήτου.',
                config: [
                    {
                        inputLabel: 'Αριθμός Κ.Η.Δ.: ',
                        inputType: 'TEXT',
                        inputValue: document.documentInput.diagramId,
                        inputReadOnly: true,
                    },
                ],
            };
        }

        if (document.documentType === 'AKD_REPORT') {
            tempDoc.rowDetails = {
                type: DATA_TABLE_DETAIL_TYPE.INPUT_FIELD,
                templateNumber: '1',
                desc: 'Για την ανάκτηση του αποσπάσματος κτηματολογικού διαγράμματος, απαιτείται συμπλήρωση των παρακάτω υποχρεωτικών πεδίων (*) και πραγματοποίηση πληρωμής αυτού, στο Κτηματολόγιο.',
                config: [
                    {
                        inputLabel: 'Αριθμός πρωτοκόλλου Α.Κ.Δ.',
                        inputType: 'TEXT',
                        inputValue: document.documentInput.protNum,
                        inputReadOnly: true,
                    },
                    {
                        inputLabel: 'Έτος πρωτοκόλλου Α.Κ.Δ.',
                        inputType: 'TEXT',
                        inputValue: document.documentInput.applyYear,
                        inputReadOnly: true,
                    },
                    // {
                    //     inputLabel: 'Κτηματολογικό γραφείο αίτησης του Α.Κ.Δ.',
                    //     inputType: 'TEXT',
                    //     inputValue: 'asdf',
                    //     inputReadOnly: true,
                    // },
                ],
            };
            tempDoc.rowDetails.documentApproved = true;
        }

        // TODO should be initialized in the frontend
        // if (document.documentInput && document.documentInput !== null) {
        //     tempDoc.rowDetails = {
        //         type: DATA_TABLE_DETAIL_TYPE.INPUT_FIELD,
        //         templateNumber: document.documentInput.templateId,
        //         desc: document.documentInput.description,
        //         config: [],
        //         documentId: document.documentId,
        //     };
        //     let countifAllValueExists = 0;
        //     document.documentInput.fieldMap.forEach((control) => {
        //         if (control['value']) {
        //             countifAllValueExists++;
        //         }

        //         tempDoc.rowDetails.config.push({
        //             inputLabel: control.title,
        //             inputType: control.type,
        //             inputValue: control.value,
        //         });
        //     });
        //     if (countifAllValueExists === tempDoc.rowDetails.config.length) {
        //         tempDoc.warning.value = null;
        //     }
        // }

        documents[documentOrder(document.documentType)] = tempDoc;
    });
    return documents.filter((elem) => elem !== undefined);
}

function mapDocumentPendingCitizenAction(document) {
    if (document.documentType !== 'AKD_REPORT') {
        return false;
    }
    if (document.documentInput === null/*  || document.documentInput === {} */) {
        return false;
    }
    if (
        document.documentInput.applyYear === null ||
        document.documentInput.protNum === null
    ) {
        return true;
    }
    return false;
}

export function labelMapper(label: string, docType: string): string {
    if (docType === 'INSURANCE') {
        switch (label) {
            case 'issueDate': {
                return 'Ημερομηνία';
            }
            case 'systemNumber': {
                return 'Αριθμός συστήματος';
            }
            case 'protocolNumber': {
                return 'Αριθμός πρωτοκόλλου';
            }
            case 'employerFullName': {
                return 'ΟΝΟΜΑΤΕΠΩΝΥΜΟ/ΕΠΩΝΥΜΙΑ';
            }
            case 'employerId': {
                return 'Α.Μ.Ε/Α.Μ.Α';
            }
            case 'taxiationNo': {
                return 'Α.Φ.Μ.';
            }
            case 'idNo': {
                return 'Α.Δ.Τ.';
            }
            //   case 'info1': {
            //     return 'Πρώτο λεκτικό με σήμανση *';
            //   }
            //   case 'info2': {
            //     return 'Δεύτερο λεκτικό με σήμανση *';
            //   }
            case 'debitInfo': {
                return 'Πληροφορίες';
            }
            case 'requestReason': {
                return 'Λόγος αίτησης';
            }
            case 'debitExpirationDate': {
                return 'Ισχύς';
            }
            case 'wittingStatus': {
                return 'Κατάσταση';
            }
            case 'webCertWitDebitDetails': {
                return 'Στοιχεία ενημερότητας';
            }
            case 'kad': {
                return 'ΚΑΔ';
            }
            case 'amka': {
                return 'ΑΜΚΑ';
            }
            case 'info1': {
                return 'Έξτρα πληροφορίες';
            }
            case 'info2': {
                return 'Έξτρα πληροφορίες 2';
            }
            case 'ownsNonSalarianFlg': {
                return 'Ένδειξη ύπαρξης χρέους ως μη-μισθωτός';
            }
            case 'true': {
                return 'ΝΑΙ';
            }
            case 'false': {
                return 'ΟΧΙ';
            }
            default: {
                return label;
            }
        }
    } else if (docType === 'ENFIA') {
        switch (label) {
            case 'certificateCode': {
                return 'Κωδικός Πιστοποιητικού';
            }
            case 'certificateDate': {
                return 'Ημερομηνία Έκδοσης';
            }
            case 'certificateReason': {
                return 'Λόγος Χρήσης';
            }
            case 'fisYear': {
                return 'Έτος';
            }
            case 'ata': {
                return 'Αριθμός Ταυτότητας Ακινήτου';
            }
            case 'kaek': {
                return 'ΚΑΕΚ';
            }
            case 'stateDescr': {
                return 'Νομός';
            }
            case 'dimos': {
                return 'Δήμος';
            }
            case 'municDescr': {
                return 'Δημοτικό ή κοινοτικό διαμέρισμα';
            }
            case 'streetDescr': {
                return 'Οδός & αριθμός';
            }
            case 'zipCd': {
                return 'Τ.Κ.';
            }
            case 'faceFlg': {
                return 'Π';
            }
            case 'street1Descr': {
                return 'Οδός';
            }
            case 'face1Flg': {
                return 'Π';
            }
            case 'street2Descr': {
                return 'Οδός';
            }
            case 'face2Flg': {
                return 'Π';
            }
            case 'street3Descr': {
                return 'Οδός';
            }
            case 'face3Flg': {
                return 'Π';
            }
            case 'facesCount': {
                return 'Πλήθος προσόψεων';
            }
            case 'blockCd': {
                return 'ΑΡΙΘΜΟΣ ΟΙΚΟΔΟΜΙΚΟΥ ΤΕΤΡΑΓΩΝΟΥ';
            }
            case 'apaaFlg': {
                return 'ΕΝΔΕΙΞΗ ΑΠΑΑ';
            }
            case 'estateCatId': {
                return 'ΚΑΤΗΓΟΡΙΑ ΑΚΙΝΗΤΟΥ';
            }
            case 'specialCond': {
                return 'ΕΙΔΙΚΩΝ ΣΥΝΘΗΚΩΝ';
            }
            case 'floorCd': {
                return 'ΟΡΟΦΟΣ';
            }
            case 'm2Main': {
                return 'ΕΠΙΦΑΝΕΙΑ ΚΥΡΙΟΙ ΧΩΡΟΙ';
            }
            case 'm2Suppl': {
                return 'ΕΠΙΦΑΝΕΙΑ ΒΟΗΘΗΤΙΚΟΙ ΧΩΡΟΙ';
            }
            case 'buildFacesLength': {
                return 'ΚΤΙΣΜΑ ΜΗΚΟΣ ΠΡΟΣΟΨΗΣ';
            }
            case 'constrYear': {
                return 'ΕΤΟΣ ΚΑΤΑΣΚΕΥΗΣ';
            }
            case 'possessionType': {
                return 'ΚΤΙΣΜΑ ΕΙΔΟΣ ΔΙΚΑΙΩΜΑΤΟΣ';
            }
            case 'possessionPrcnt1': {
                return 'ΚΤΙΣΜΑ ΠΟΣΟΣΤΟ ΣΥΝΙΔΙΟΚΤΗΣΙΑΣ';
            }
            case 'epikYob1': {
                return 'ΚΤΙΣΜΑ ΕΤΟΣ ΓΕΝΝΗΣΗΣ ΕΠΙΚΑΡΠΩΤΗ';
            }
            case 'm2Land': {
                return 'ΟΙΚΟΠΕΔΟ ΕΠΙΦΑΝΕΙΑ';
            }
            case 'landFacesLength': {
                return 'ΟΙΚΟΠΕΔΟ ΜΗΚΟΣ ΠΡΟΣΟΨΗΣ';
            }
            case 'possessionType2': {
                return 'ΟΙΚΟΠΕΔΟ ΕΙΔΟΣ ΔΙΚΑΙΩΜΑΤΟΣ';
            }
            case 'possessionPrcnt2': {
                return 'ΟΙΚΟΠΕΔΟ ΠΟΣΟΣΤΟ ΣΥΝΙΔΙΟΚΤΗΣΙΑΣ';
            }
            case 'electricSupplyFlg': {
                return 'ΤΟ ΑΚΙΝΗΤΟ ΕΙΝΑΙ ΗΛΕΚΤΡΟΔΟΤΟΥΜΕΝΟ';
            }
            case 'electricSupplyNbrs': {
                return 'ΑΡΙΘΜΟΣ ΠΑΡΟΧΗΣ ΗΛΕΚΤΡΙΚΟΥ/ΕΡΓΟΤΑΞΙΑΚΟΥ ΡΕΥΜΑΤΟΣ';
            }
            default: {
                return label;
            }
        }
    }

    return label;
}

function mapDocumentStatus(documentState: string) {
    switch (documentState) {
        case 'INITIALIZED':
            return DOCUMENT_STATUS.INITIALIZED;
        case 'UPLOAD_NEEDED':
            return DOCUMENT_STATUS.UPLOAD_NEEDED;
        case 'WEB_SERVICE_INPUT_NEEDED':
            return DOCUMENT_STATUS.WEB_SERVICE_INPUT_NEEDED;
        case 'INPUT_NEEDED':
            return DOCUMENT_STATUS.INPUT_NEEDED;
        case 'READY_TO_DOWNLOAD':
            return DOCUMENT_STATUS.READY_TO_DOWNLOAD;
        case 'NOT_NEEDED':
            return DOCUMENT_STATUS.NOT_NEEDED;
        case 'READY':
            return DOCUMENT_STATUS.READY;
        case 'APPROVED':
            return DOCUMENT_STATUS.APPROVED;
        case 'DELETED':
            return DOCUMENT_STATUS.DELETED;
        default:
            return '-';
    }
}

export function mapProperties(response) {
    if (response.length < 1) {
        const tempProp = {
            buildingAddress: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: `Δεν βρέθηκαν ακίνητα`,
            },
            atak: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: '-',
            },
            ownerFullName: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: '-',
            },
            rowSelected: SELECT_TABLE_ROW_STATUS.NOT_CHECKED,
        };
        return [tempProp];
    }
    return response.map((document) => {
        const tempProp = {
            buildingAddress: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: `${
                    document.addressStreet ? document.addressStreet : ''
                } ${document.addessStreetNo ? document.addessStreetNo : ''} ${
                    document.addressZipCode
                        ? ', ' + document.addressZipCode
                        : ''
                } ${document.dimos ? ', ' + document.dimos : ''} ${
                    document.nomosNomarxia ? ', ' + document.nomosNomarxia : ''
                } ${
                    document.estateCatDescription
                        ? '<br>' + document.estateCatDescription
                        : ''
                }
          `,
            },
            atak: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: document.atak,
            },
            ownerFullName: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: `${
                    document.possessionPrcntBuild
                        ? 'Επί του κτηρίου: ' +
                          document.possessionPrcntBuild +
                          '% Τύπος κυριότητας: ' +
                          document.possessionTypeBuild +
                          '<br>'
                        : ''
                } ${
                    document.possessionPrcntLand
                        ? 'Επί του οικοπέδου: ' +
                          document.possessionPrcntLand +
                          '% Τύπος κυριότητας: ' +
                          document.possessionTypeLand
                        : ''
                }`,
            },
            rowSelected: SELECT_TABLE_ROW_STATUS.NOT_CHECKED,
            isNotEligible: {
                type: DATA_TABLE_CELL_TYPE.WARNING,
                value: !document.isEligible,
            },
        };
        return tempProp;
    });
}

export function mapActions(
    document,
    appId?,
    actionCallbackConfigs?: ActionCallbackConfig[]
) {
  // console.log(document, appId, actionCallbackConfigs);

    let buttons = actionCallbackConfigs
        ?.filter((config) => config.documentType === document.documentType);

    if(document.documentState == 'ERROR_RETRIEVING')
      buttons.push({
            actionCallback: (data) => console.log('here'),
            documentType: document.documentType,
            label: 'Λόγω προβλήματος επικοινωνίας παρακαλώ μεταφορτώστε ξανά το απαραίτητο δικαιολογητικό και επιβεβαιώστε ότι έχει ελεγχθεί, επιλέγοντας το αντίστοιχο πεδίο (checkbox - Έλεγχος Εγγράφου από Συμβολαιογράφο).',
            class: 'lbl'
        },
      )

  console.log(buttons);

    return buttons
        .map((fn) => ({
            label: fn.label,
            otherProperties: {
                appId,
                docId: document.documentId,
                documentState: document.documentState,
                documentOutputDesc: document.documentOutputDescList,
                isFileUploaded: document.isFileUploaded,
                documentOutput: document.documentOutput,
            },
            classes: [
                fn.class?fn.class:'table-btn',
                document.documentState === 'ERROR_RETRIEVING' &&
                !(
                    document.documentType === 'AFE_ISSUE_DOCUMENT' &&
                    document.documentOutputDescList != null &&
                    document.documentOutputDescList.length > 0
                )
                    ? 'button-error'
                    : '',
            ],
            disabled:
                fn.label === 'Μεταφόρτωση'
                    ? mapUploadButtonAvailability(
                          document.documentState,
                          document.documentType,
                          document.notaryApproval
                      )
                    : fn.label === 'Συμπλήρωση'
                    ? false
                    : // ? !mapDocumentPendingCitizenAction(document)
                      mapButtonAvailability(
                          document.documentState,
                          document.documentType,
                          document.documentOutputDescList
                      ),
            actionCallback: fn.actionCallback,
            tip: fn.tip,
            uploadLink: document.documentType,
        }));
    // return actions;
}

/**
 * Check if an upload button should be disabled based on a specific document state
 * @param state - State of the document
 * @param documentType - Document Type  Used to handle specific cases
 * @returns {boolean} - Whether the button should be disabled or not
 */
function mapUploadButtonAvailability(
    state: string,
    documentType = '',
    notaryApproval : boolean
): boolean {



    if(notaryApproval == true && ['AFE_ISSUE_DOCUMENT','INSURANCE_CERTIFICATE' ,'ENFIA_CERTIFICATE'].includes(documentType)){

      return true
    }

    if (documentType === 'AFE_ISSUE_DOCUMENT') {
        return false;
        // switch (state) {
        //     case 'ERROR_RETRIEVING': {
        //         return false;
        //     }
        //     case 'READY': {
        //         return false;
        //     }
        //     default: {
        //         return true;
        //     }
        // }
    } else if (documentType === 'INSURANCE_CERTIFICATE') {
        return false;
        // switch (state) {
        //     case 'READY': {
        //         return false;
        //     }
        //     case 'UPLOAD_NEEDED': {
        //         return false;
        //     }
        //     default: {
        //         return true;
        //     }
        // }
    }
    switch (state) {
        // case 'INPUT_NEEDED':
        //     return false;
        // case 'READY':
        //     return false;
        case 'APPROVED':
            return true;
        default:
            return false;
    }
}

function mapButtonAvailability(
    state: string,
    type: string,
    output: string
): boolean {
    switch (state) {
        // case 'INPUT_NEEDED':
        //     return false;
        case 'APPROVED':
            return false;
        case 'READY':
            return false;
        case 'ERROR_RETRIEVING':
            if (
                type === 'AFE_ISSUE_DOCUMENT' &&
                output != null &&
                output.length > 0
            ) {
                return false;
            }
            return true;
        case 'UPLOAD_NEEDED': {
            if (type === 'INSURANCE_CERTIFICATE') {
                return false;
            }
            return true;
        }
        default:
            return true;
    }
}

export function mapDocumentsInfo(
    response,
    appId?,
    actionCallbackConfigs?: ActionCallbackConfig[]
) {
    let tempDocumentsInfo;
    tempDocumentsInfo = {
        headers: {
            documentTitle: 'Τίτλος Εγγράφου',
            documentValidityDuration: 'Διάρκεια ισχύος Εγγράφου',
            documentStatus: 'Κατάσταση Εγγράφου',
            warning: '',
            action: 'Ενέργειες',
        },
        data: mapDocuments(response, appId, actionCallbackConfigs),
        status: response.status,
    };
    return tempDocumentsInfo;
}

export function mapPropertiesInfo(response) {
    let tempPropertiesInfo;
    tempPropertiesInfo = {
        headers: {
            buildingAddress: 'Διεύθυνση Ακινήτου',
            atakNumber: 'Α.Τ.ΑΚ.',
            ownerFullName: 'Ποσοστό Συνιδιοκτησίας',
        },
        data: mapProperties(response),
    };
    return tempPropertiesInfo;
}

// export function mapPropertiesInfoForSeller(response) {
//     let tempPropertiesInfo;
//     tempPropertiesInfo = {
//         headers: {
//             buildingAddress: 'Διεύθυνση Ακινήτου',
//             ownerFullName: 'Πωλητής',
//         },
//         data: mapPropertiesForSeller(response),
//     };
//     return tempPropertiesInfo;
// }

export function mapPropertiesForSeller(response) {
    let documents = [];
    if (response.length < 1) {
        const tempProp = {
            buildingAddress: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: `Δεν βρέθηκαν ακίνητα`,
            },
            atak: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: '-',
            },
            ownerFullName: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: '-',
            },
            rowSelected: SELECT_TABLE_ROW_STATUS.NOT_CHECKED,
        };

        documents.push(tempProp);
        return documents;
    }

    response
        .filter((e) => e != null && e.involvedProperties)
        .map((e) =>
            e.involvedProperties.map((doc) =>
                parsePropertyItem(e.fullname, doc)
            )
        )
        .forEach((item) => {
            if (Array.isArray(item)) {
                documents.push(...item);
            } else {
                documents.push(item);
            }
        });
    return documents;
}

function parsePropertyItem(fullname, document) {
    console.log('checking document', document);
    //if (!document || !document.fullname) return null;

    const tempProp = {
        buildingAddress: {
            type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
            value: `${document?.addressEstate ?? '-'} <br/> ${
                document?.descriptionEstate
            }
    `,
        },
        atak: {
            type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
            value: document?.atakNumber,
        },
        ownerFullName: {
            type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
            value: `${fullname ?? '-'}`,
        },
        rowSelected: SELECT_TABLE_ROW_STATUS.NOT_CHECKED,
        isNotEligible: {
            type: DATA_TABLE_CELL_TYPE.WARNING,
            value: false,
        },
    };
    return tempProp;
}

export function mapNotaryRequestSummary(response, config, buyerSellerText): InfoTableConfig {
    let tempRequestSummary;
    tempRequestSummary = {
        infoTableBackground: config,
        infoTableData: [
            {
                headers: [
                    {
                        requestNumber: 'Κωδικός Αιτήματος',
                        buyersAfm: `ΑΦΜ  ${buyerSellerText['acquiringText']}`,
                        buyersName: `Ονοματεπώνυμο ${buyerSellerText['acquiringText']}`,
                        sellersAfm: `ΑΦΜ ${buyerSellerText['transferringText']}`,
                        sellerName: `Ονοματεπώνυμο ${buyerSellerText['transferringText']}`,
                        submissionDate: 'Ημερομηνία Υποβολής',
                    },
                ],
                data: [
                    {
                        requestNumber: response.id,
                        buyersAfm: taxNumbersToArray(
                            response.involvedParties,
                            'BUYER'
                        ),
                        buyersName: namesToArray(
                            response.involvedParties,
                            'BUYER'
                        ),
                        sellersAfm: taxNumbersToArray(
                            response.involvedParties,
                            'SELLER'
                        ),
                        sellerName: namesToArray(
                            response.involvedParties,
                            'SELLER'
                        ),
                        submissionDate: dateFormat(response.submissionDate),
                    },
                ],
            },
        ],
        addressEstate: response.addressEstate,
        atakNumber: response.atakNumber,
    };

    return tempRequestSummary;
}

export function mapContractingPeople(response): InfoTableConfig {
    let tempContractingPeople;

    tempContractingPeople = {
        infoTableSectionTitle: {
            imgPath: 'assets/images/user.png',
            sectionTitle: 'Προσωπικά στοιχεία συμβαλλόμενων προσώπων',
            altText: 'papyrus icon for table title',
        },
        infoTableData: [
            {
                cardHeader: 'Στοιχεία πωλητή  με ΑΦΜ : 12345678912',
                headers: [
                    {
                        fullName: 'Ονοματεπώνυμο',
                        idNumber: 'Αριθμός Ταυτότητας',
                        fathersName: 'Όνομα Πατρός',
                        birthday: 'Ημερομηνία Γέννησης',
                        idIssuingAuthority: 'Αρχή Έκδοσης Δελτίου Ταυτότητας',
                        occupation: 'Επάγγελμα',
                    },
                    {
                        homeAddress: 'Διεύθυνση Κατοικίας',
                        homeZipCode: 'Τ.Κ. Κατοικίας',
                        incomeDoy: 'Δ.Ο.Υ. Εισοδήματος',
                        familyState: 'Οικογενειακή Κατάσταση',
                    },
                ],
                data: mapPeople(response),
            },
        ],
        infoTableBackground: {
            backgroundColor: '#F5F5F5',
            rowColor: '#FFFFFF',
        },
    };

    return tempContractingPeople;
}

export function mapPeople(response) {
    let tempPeople = [];

    response.contractingPeople.map((person) => {
        tempPeople.push({
            fullName: person.fullname,
            idNumber: person.identityCardNo,
            fathersName: person.fathersName,
            birthday: person.birthDate,
            idIssuingAuthority: person.identityCardIssuer,
            occupation: person.profession,
        });
        tempPeople.push({
            homeAddress: person.address,
            homeZipCode: person.zipCode,
            incomeDoy: person.taxOffice,
            familyState: person.maritalStatus,
        });
    });

    return tempPeople;
}

export function mapPerson(person) {
    let tempPersonInfo = [];

    tempPersonInfo.push({
        fullName: person.involvedPartyDetails.fullname,
        idNumber: person.involvedPartyDetails.policeIdentity,
        fathersName: person.involvedPartyDetails.fatherFirstName,
        // birthday: dateFormat(person.involvedPartyDetails.dateOfBirth),
        birthday: person.involvedPartyDetails.dateOfBirth,
        idIssuingAuthority: person.involvedPartyDetails.issuedPoliceIdentity,
        occupation: person.involvedPartyDetails.occupation,
    });
    tempPersonInfo.push({
        homeAddress: person.involvedPartyDetails.residenceAddress,
        homeZipCode: person.involvedPartyDetails.zipCode,
        incomeDoy: person.involvedPartyDetails.taxOffice,
        familyState: person.involvedPartyDetails.martialStatus,
    });

    return tempPersonInfo;
}

export function mapCompany(company) {
    let tempCompanyInfo = [];

    tempCompanyInfo.push({
        fullName: company.involvedPartyDetails.fullname,
        homeAddress: company.involvedPartyDetails.residenceAddress,
        homeZipCode: company.involvedPartyDetails.zipCode,
        incomeDoy: company.involvedPartyDetails.taxOffice,
    });

    return tempCompanyInfo;
}

export function involvedPartiesConsents(involvedParties, buyerSellerText) {
    let tempInvolvedPartiesInfo = [];

    involvedParties.forEach((involvedParty) => {
      tempInvolvedPartiesInfo.push({
            taxNumber: involvedParty.vatId,
            fullName: involvedParty.involvedPartyDetails.fullname,
            role: (involvedParty.role === USER_CAPACITY.BUYER)
                        ? buyerSellerText['acquiringText']
                        : buyerSellerText['transferringText'],
            consent: (involvedParty.acceptStatus === 'ACCEPTED')
                        ? 'ΝΑΙ'
                        : 'ΟΧΙ',
            atakSelection: (involvedParty.involvedProperties.length === 0)
                        ? 'ΟΧΙ'
                        : 'ΝΑΙ',
        });
    });

    return tempInvolvedPartiesInfo;
}

export function mapPropertiesForSale(people) {
  let tempPropertyInfo = [];

  people.forEach((person) => {
      if (person.role === USER_CAPACITY.SELLER && person.involvedProperties) {
          person.involvedProperties.forEach((property) => {
              tempPropertyInfo.push({
                  address: property.descriptionEstate
                      ? property.addressEstate +
                        '<br>' +
                        property.descriptionEstate
                      : property.addressEstate,
                  seller: person.involvedPartyDetails
                      ? person.involvedPartyDetails.fullname
                      : person.fullname,
                  atak: property.atakNumber,
              });
          });
      }
  });

  return tempPropertyInfo;
}

export function mapPropertiesForSaleBuyer(people) {
  let tempPropertyInfo = [];

  people.forEach((person) => {
      if (person.role === USER_CAPACITY.SELLER && person.involvedProperties) {
          person.involvedProperties.forEach((property) => {
              tempPropertyInfo.push({
                  address: property.descriptionEstate
                      ? property.addressEstate +
                        '<br>' +
                        property.descriptionEstate
                      : property.addressEstate,
                  seller: person.involvedPartyDetails
                      ? person.involvedPartyDetails.fullname
                      : person.fullname,
              });
          });
      }
  });

  return tempPropertyInfo;
}

function dateFormat(birthdayDate: string) {
    if (!birthdayDate) return '';
    const date = new Date(birthdayDate);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    return `${dt}/${month}/${year}`;
}

// export function mapPerson(person) {
//     let tempPersonInfo = [];

//     tempPersonInfo.push({
//         fullName: person.fullName,
//         idNumber: person.identityCardNo,
//         fathersName: person.fathersName,
//         birthday: person.birthDate,
//         idIssuingAuthority: person.identityCardIssuer,
//         occupation: person.profession,
//     });
//     tempPersonInfo.push({
//         homeAddress: person.address,
//         homeZipCode: person.zipCode,
//         incomeDoy: person.taxOffice,
//         familyState: person.maritalStatus,
//     });

//     return tempPersonInfo;
// }

export function prepareInfoTableDataForContractingPeople(
    people,
    capacity,
    buyerSellerText
): InfoTableData[] {
    return people
        .filter((person) => person.role === capacity)
        .map((person) => {
            if(person.involvedPartyDetails && typeof person.involvedPartyDetails.individual != 'undefined' && person.involvedPartyDetails.individual === false){
              return {
                  cardHeader: `Στοιχεία ${
                      capacity === 'BUYER' ? buyerSellerText['acquiringText'] : buyerSellerText['transferringText']
                  } με ΑΦΜ : ${person.vatId}`,
                  headers: [
                      {
                          fullName: 'Επωνυμία',
                          homeAddress: 'Διεύθυνση Νομικού Προσώπου',
                          homeZipCode: 'Τ.Κ. Νομικού Προσώπου',
                          incomeDoy: 'Δ.Ο.Υ. Νομικού Προσώπου',
                      }
                  ],
                  data: mapCompany(person),
              };
            } else {
                return {
                    cardHeader: `Στοιχεία ${
                        capacity === 'BUYER' ? buyerSellerText['acquiringText'] : buyerSellerText['transferringText']
                    } με ΑΦΜ : ${person.vatId}`,
                    headers: [
                        {
                            fullName: 'Ονοματεπώνυμο',
                            idNumber: 'Αριθμός Ταυτότητας',
                            fathersName: 'Όνομα Πατρός',
                            birthday: 'Ημερομηνία Γέννησης',
                            idIssuingAuthority: 'Αρχή Έκδοσης Δελτίου Ταυτότητας',
                            occupation: 'Επάγγελμα',
                        },
                        {
                            homeAddress: 'Διεύθυνση Κατοικίας',
                            homeZipCode: 'Τ.Κ. Κατοικίας',
                            incomeDoy: 'Δ.Ο.Υ. Εισοδήματος',
                            familyState: 'Οικογενειακή Κατάσταση',
                        },
                    ],
                    data: mapPerson(person),
                };
            }
        });
}
// export function prepareInfoTableDataForContractingPeople(
//     people,
//     capacity
// ): InfoTableData[] {
//     return people
//         .filter((person) => person.capacity !== capacity)
//         .map((person) => {
//             return {
//                 cardHeader: `Στοιχεία ${
//                     capacity === 'BUYER' ? 'πωλητή' : 'αγοραστή'
//                 } με ΑΦΜ : ${person.taxNumber}`,
//                 headers: [
//                     {
//                         fullName: 'Ονοματεπώνυμο',
//                         idNumber: 'Αριθμός Ταυτότητας',
//                         fathersName: 'Όνομα Πατρός',
//                         birthday: 'Ημερομηνία Γέννησης',
//                         idIssuingAuthority: 'Αρχή Έκδοσης Δελτίου Ταυτότητας',
//                         occupation: 'Επάγγελμα',
//                     },
//                     {
//                         homeAddress: 'Διεύθυνση Κατοικίας',
//                         homeZipCode: 'Τ.Κ. Κατοικίας',
//                         incomeDoy: 'Δ.Ο.Υ. Εισοδήματος',
//                         familyState: 'Οικογενειακή Κατάσταση',
//                     },
//                 ],
//                 data: mapPerson(person),
//             };
//         });
// }

export function mapContractingPeopleByCapacity(
    people,
    capacity,
    buyerSellerText
): InfoTableConfig {
    let tempContractingPerson;

    if (capacity === 'BUYER') {
        tempContractingPerson = {
            infoTableSectionTitle: {
                imgPath: 'assets/images/user.png',
                sectionTitle: 'Προσωπικά στοιχεία συμβαλλόμενων προσώπων',
                altText: 'papyrus icon for table title',
            },
            infoTableData: prepareInfoTableDataForContractingPeople(
                people,
                capacity,
                buyerSellerText
            ),
            infoTableBackground: {
                backgroundColor: '#F5F5F5',
                rowColor: '#FFFFFF',
            },
        };
    } else if (capacity === 'SELLER') {
        tempContractingPerson = {
            infoTableSectionTitle: {
                imgPath: 'assets/images/user.png',
                sectionTitle: 'Προσωπικά στοιχεία συμβαλλόμενων προσώπων',
                altText: 'papyrus icon for table title',
            },
            infoTableData: prepareInfoTableDataForContractingPeople(
                people,
                capacity,
                buyerSellerText
            ),
            infoTableBackground: {
                backgroundColor: '#F5F5F5',
                rowColor: '#FFFFFF',
            },
        };
    }
    return tempContractingPerson;
}

export function mapAllSelectedProperties(person, transferringText): InfoTableConfig {
    let tempContractingPerson;
    tempContractingPerson = {
        infoTableSectionTitle: {
            imgPath: 'assets/images/table.png',
            sectionTitle: 'Επιλεγμένα Ακίνητα',
            altText: 'papyrus icon for table title',
        },
        infoTableData: [
            {
                headers: [
                    {
                        address: 'Διεύθυνση Ακινήτου',
                        seller: transferringText,
                        atak: 'Α.Τ.ΑΚ.'
                    },
                ],
                data: mapPropertiesForSale(person),
            },
        ],
        infoTableBackground: {
            backgroundColor: '#F5F5F5',
            rowColor: '#FFFFFF',
        },
    };

    return tempContractingPerson;
}

export function mapAllinvolvedPartiesConsents(involvedParties, buyerSellerText): InfoTableConfig {
  let tempInvolvedPartiesConsents;
  tempInvolvedPartiesConsents = {
      infoTableSectionTitle: {
          imgPath: 'assets/images/table.png',
          sectionTitle: 'Κατάσταση Απόδοχής Πρόσκλησης από Συμβαλλομένους',
          altText: 'papyrus icon for table title',
      },
      infoTableData: [
          {
              headers: [
                  {
                      taxNumber: 'ΑΦΜ',
                      fullName: 'Ονοματεπώνυμο',
                      role: 'Ρόλος',
                      consent: 'Αποδοχή Πρόσκλησης',
                      atakSelection: 'Επιλογή Ακινήτου',
                  },
              ],
              data: involvedPartiesConsents(involvedParties, buyerSellerText),
          },
      ],
      infoTableBackground: {
          backgroundColor: '#F5F5F5',
          rowColor: '#FFFFFF',
      },
  };

  return tempInvolvedPartiesConsents;
}

export function mapAllSelectedPropertiesForSeller(person): InfoTableConfig {
    let tempContractingPerson;
    tempContractingPerson = {
        infoTableData: [
            {
                headers: [
                    {
                        address: 'Διεύθυνση Ακινήτου',
                        seller: 'Πωλητής',
                    },
                ],
                data: mapPropertiesForSaleBuyer(person),
            },
        ],
        infoTableBackground: {
            backgroundColor: '#F5F5F5',
            rowColor: '#FFFFFF',
        },
    };

    return tempContractingPerson;
}

export function mapAllSelectedPropertiesForSellerAsDataTable(sellers: any[]) {}

// = {transferringText: "Πωλητής", acquiringText: "Αγοραστής"}
export function mapAllContractingPeopleByCapacity(people, buyerSellerText): InfoTableConfig {
    let tempContractingPerson;
    tempContractingPerson = {
        infoTableSectionTitle: {
            imgPath: 'assets/images/user.png',
            sectionTitle: 'Προσωπικά στοιχεία συμβαλλόμενων προσώπων',
            altText: 'Προσωπικά στοιχεία συμβαλλόμενων προσώπων',
        },
        infoTableData: prepareInfoTableDataForContractingPeople(
            people,
            'BUYER',
            buyerSellerText
        ).concat(prepareInfoTableDataForContractingPeople(people, 'SELLER', buyerSellerText)),
        infoTableBackground: {
            backgroundColor: '#F5F5F5',
            rowColor: '#FFFFFF',
        },
    };

    return tempContractingPerson;
}

export function mapNotaryDocumentsInfo(
    response,
    appId?,
    actionCallbackConfigs?: ActionCallbackConfig[]
) {
    let tempDocumentsInfo;

    tempDocumentsInfo = {
      headers: {
          documentPublicSectorOwner: 'Φορέας',
          documentTitle: 'Τίτλος Εγγράφου',
          documentValidityDuration: 'Διάρκεια ισχύος Εγγράφου',
          documentValidityByDuration: 'Εγκυρότητα ισχύος Εγγράφου',
          documentCheckedByNotary: 'Έλεγχος Εγγράφου από Συμβολαιογράφο',
          refreshEnabled: '',
          action: 'Ενέργεια',
      },
      data: mapNotaryDocuments(response, appId, actionCallbackConfigs),
      status: response.status,
    };
    return tempDocumentsInfo;
}

function isNotaryCheckDisabled(
    documentType: string,
    documentState: string,
    checkBoxValue
): boolean {

    if (  !checkBoxValue && (
            ['ENFIA_CERTIFICATE'].includes(documentType) || ['COMPLETION_CERTIFICATE'].includes(documentType) ||
            ['FLOOR_PLANS'].includes(documentType) || ['ENERGY_EFFICIENCY_CERTIFICATE'].includes(documentType)
          )
        ) {
       return false;
    }

    //return false;
    return documentState !== 'READY' && documentState !== 'NOT_NEEDED';
}

export function mapNotaryDocuments(
    response,
    appId?,
    actionCallbackConfigs?: ActionCallbackConfig[]
) {
    let documents = [];
    response.map((document) => {
        const tempDoc = {
            documentId: {
                type: DATA_TABLE_CELL_TYPE.NOT_SHOWN,
                value: document.documentId,
            },
            documentPublicSerctorOwner: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapDocumentPublicSectorOwner(document.documentType),
            },
            documentTitle: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapDocumentTitle(document.documentType),
                revertLink: mapDocumentRevertLink(document.documentType),
                docType: mapDocumentRevertTypeLink(document.documentType),
            },
            documentValidityDuration: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapDocumentDuration(
                    document.documentType,
                    document.documentExpirationInDays
                ),
            },
            documentValidityByDuration: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapDocumentValidityByDuration(
                    document.documentOutput,
                    document.documentType,
                    document.documentExpirationInDays,
                    document.documentState
                ),
            },
            documentCheckedByNotary: {
                type: DATA_TABLE_CELL_TYPE.CHECKBOX,
                value: document.notaryApproval,
                checkboxDisabled: isNotaryCheckDisabled(
                    document.documentType,
                    document.documentState,
                    document.notaryApproval
                ),
                // checkboxDisabled:
                //     document.documentState !== 'READY' &&
                //     document.documentState !== 'NOT_NEEDED',
            },
            refreshEnabled: {
                type: DATA_TABLE_CELL_TYPE.REFRESH,
                value: document.isRefreshable,
            },
            action: {
                type: DATA_TABLE_CELL_TYPE.ACTION,
                value: mapActions(document, appId, actionCallbackConfigs),
            },
            atakNumber: {
                type: DATA_TABLE_CELL_TYPE.NOT_SHOWN,
                //value: document.documentInput.atakNumber,
                value: document.atakNumber,
            },
            citizenTaxNumber: {
              type: DATA_TABLE_CELL_TYPE.NOT_SHOWN,
              value: document.citizenTaxNumber,
            },
            rowDetails: null,
            rowDisabled: mapRowDisabled(document),
        };

        const labelTypeRows = [
            'ENFIA_CERTIFICATE',
            'AFE_ISSUE_DOCUMENT',
            'INSURANCE_CERTIFICATE',
        ];
        if (labelTypeRows.includes(document.documentType)) {
            tempDoc.rowDetails = {
                type: DATA_TABLE_DETAIL_TYPE.READONLY_LABEL,
                templateNumber: '0',
                desc: '',
                config: [
                    {
                        label: '* Στην περίπτωση που το έγγραφο δεν έχει επιστραφεί από το Φορέα μπορείτε να χρησιμοποιήσετε την επιλογή Μεταφόρτωση.',
                    },
                ],
            };
            if (document.documentType === 'ENFIA_CERTIFICATE') {
                tempDoc.rowDetails.config.push({
                    label: '** Εάν το παρόν έγγραφο δεν είναι απαραίτητο για την τρέχουσα πράξη, παρακαλώ όπως επιλέξετε την ένδειξη ότι ελέγχθηκε άνευ παρουσίας εγγράφου.',
                });
            }
        }
        const labelTeeTypeRows = [
          'COMPLETION_CERTIFICATE',
          'ENERGY_EFFICIENCY_CERTIFICATE',
          'FLOOR_PLANS',
        ];
        if (labelTeeTypeRows.includes(document.documentType) && !['CIVIL_ENGINEER_CERTIFICATE'].includes(document.documentType)) {
            tempDoc.rowDetails = {
                type: DATA_TABLE_DETAIL_TYPE.READONLY_LABEL,
                templateNumber: '0',
                desc: '',
                config: [
                    {
                        label: '* Στην περίπτωση που το έγγραφο δεν έχει επιστραφεί από το Φορέα μπορείτε να χρησιμοποιήσετε την επιλογή Μεταφόρτωση,',
                    },
                ],
            };

            tempDoc.rowDetails.config.push({
              label: '** Εάν το παρόν έγγραφο δεν είναι απαραίτητο για την τρέχουσα πράξη, παρακαλώ όπως επιλέξετε την ένδειξη ότι ελέγχθηκε άνευ παρουσίας εγγράφου.',
            });
        }
        if (document.documentType === 'CIVIL_ENGINEER_CERTIFICATE') {
          tempDoc.rowDetails = {
              type: DATA_TABLE_DETAIL_TYPE.READONLY_LABEL,
              templateNumber: '0',
              desc: '',
              config: [
                  {
                      label: '* Στην περίπτωση που το έγγραφο δεν έχει επιστραφεί από το Φορέα μπορείτε να χρησιμοποιήσετε την επιλογή Μεταφόρτωση,',
                  },
              ],
          };
          /*
          tempDoc.rowDetails.config.push({
            label: '** Εάν το παρόν έγγραφο δεν είναι απαραίτητο για την τρέχουσα πράξη, παρακαλώ όπως επιλέξετε την ένδειξη ότι ελέγχθηκε άνευ παρουσίας εγγράφου.',
          });
          */
        }
        if (document.documentType === 'DIAGRAM_REPORT') {
            tempDoc.rowDetails = {
                type: DATA_TABLE_DETAIL_TYPE.INPUT_FIELD,
                templateNumber: '1',
                desc: null,
                config: [
                    {
                        inputLabel:
                            'Απαιτείται τοπογραφικό διάγραμμα βάσει του υπό μεταβιβαζόμενου ακινήτου; '+
                            'Εάν NAI (απαιτείται τοπογραφικό διάγραμμα) η επιλογή δεξιά πρέπει να παραμείνει μπλέ, διαφορετικά εάν ΟΧΙ '+
                            '(ΔΕΝ απαιτείται τοπογραφικό διάγραμμα) η επιλογή δεξιά πρέπει πρέπει να γίνει γκρι.',
                        inputType: 'TOGGLE',
                        inputValue: document.documentState !== 'NOT_NEEDED',
                        inputReadOnly: false,
                    },
                    {
                        inputLabel: 'Αριθμός Κ.Η.Δ. (Γράψτε τον αριθμό, πατήστε συμπλήρωση και μετά πατήστε τα πράσινα κυκλικά βελάκια δίπλα στην μεταφόρτωση για να ανακτηθεί το έγγραφο. Σε περίπτωση σφάλματος μη ανάκτησης προβείτε σε Μεταφόρτωση)',
                        inputType: 'TEXT',
                        inputValue: document.documentInput.diagramId,
                        inputReadOnly: false,
                    },
                    {
                        inputLabel: 'Συμπλήρωση',
                        inputType: 'BUTTON',
                        inputValue: null,
                        inputReadOnly: false,
                    },
                ],
            };
        }

        if (document.documentType === 'AKD_REPORT') {
            tempDoc.rowDetails = {
                type: DATA_TABLE_DETAIL_TYPE.INPUT_FIELD,
                templateNumber: '2',
                desc: 'Το Α.Κ.Δ. θα ανακτηθεί εφόσον ο/οι εμπλεκόμενος/οι πωλητής/ες έχει/ουν διεκπεραιώσει την πληρωμή έκδοσης του Α.Κ.Δ. στο κτηματολόγιο.',
                config: [
                    {
                        inputLabel: 'Αριθμός πρωτοκόλλου Α.Κ.Δ.',
                        inputType: 'TEXT',
                        inputValue: document.documentInput.protNum,
                        inputReadOnly: false,
                    },
                    {
                        inputLabel: 'Έτος πρωτοκόλλου Α.Κ.Δ.',
                        inputType: 'TEXT',
                        inputValue: document.documentInput.applyYear,
                        inputReadOnly: false,
                    },
                ],
            };
        }

        if (
            tempDoc.rowDetails !== null &&
            document.documentState === 'APPROVED'
        ) {
            tempDoc.rowDetails.documentApproved = true;
        }

        documents[documentOrder(document.documentType)] = tempDoc;
    });
    return documents.filter((elem) => elem !== undefined);
}

function mapRowDisabled(document): boolean {
    switch (document.documentType) {
        case 'AKD_REPORT':
        //case 'COMPLETION_CERTIFICATE':
        //case 'ENERGY_EFFICIENCY_CERTIFICATE':
        //case 'FLOOR_PLANS':
            if (
                document.documentInput.kaekNumber &&
                document.documentInput.kaekNumber !== null &&
                document.documentInput.kaekNumber !== ''
            ) {
                return false;
            }
            return true;
        default:
            return false;
    }
}

function documentOrder(documentType): number {
    switch (documentType) {
        case 'CONTRACT':
            return 0;
        case 'ENFIA_CERTIFICATE':
            return 3;
        case 'AFE_ISSUE_DOCUMENT':
            return 4;
        case 'MUNICIPALITY_CERTIFICATE':
            return 5;
        case 'INSURANCE_CERTIFICATE':
            return 6;
        case 'CIVIL_ENGINEER_CERTIFICATE':
            return 7;
        case 'COMPLETION_CERTIFICATE':
            return 8;
        case 'FLOOR_PLANS':
            return 9;
        case 'ENERGY_EFFICIENCY_CERTIFICATE':
            return 10;
        case 'DIAGRAM_REPORT':
            return 11;
        case 'AKD_REPORT':
            return 12;
        case 'TEEBUILD_DOCUMENTS':
            return 7;
        case 'CADASTRAL_DOCUMENTS':
            return 11;
        case 'GENERAL_GEMI_CERTIFICATE':
            return 1;
        case 'GEMI_CERTIFICATE_OF_REPRESENTATION':
            return 2;
        case 'DEATH_CERTIFICATE':
            return 13;
        case 'PROOF_OF_PAYMENT':
            return 0;
        default:
            return -1;
    }
}

function mapByDocumentType(documentType) {
    switch (documentType) {
        case 'AFE_ISSUE_DOCUMENT':
            return 'Δύο (2) μήνες από την έκδοση του';
        case 'DIAGRAM_REPORT':
            return 'Δύο (2) μήνες από την έκδοση του';
        case 'AKD_REPORT':
            return '-';
        case 'ENFIA_CERTIFICATE':
            return '-';
        case 'CIVIL_ENGINEER_CERTIFICATE':
            return 'Δύο (2) μήνες από την έκδοση του';
        case 'COMPLETION_CERTIFICATE':
            return 'Δύο (2) μήνες από την έκδοση του';
        case 'ENERGY_EFFICIENCY_CERTIFICATE':
            return 'Δέκα (10) έτη';
        case 'FLOOR_PLANS':
            return '-';
        case 'INSURANCE_CERTIFICATE':
            return 'Έξι (6) μήνες, αν δεν υφίσταται οφειλή ή ...';
        case 'CONTRACT':
            return '-';
        case 'PROOF_OF_PAYMENT':
            return '-';
        case 'MUNICIPALITY_CERTIFICATE':
            return 'Μέχρι την 31/12 του έτους έκδοσης';
        default:
            return '-';
    }
}

export function mapDocumentValidityByDuration(
    documentOutput,
    documentType,
    documentExpirationInDays,
    documentState
) {
    switch (documentType) {
        case 'CONTRACT':
        case 'AKD_REPORT':
            return '-';
        default:
            if (documentState === 'ERROR_RETRIEVING') {
                if (documentType === 'AFE_ISSUE_DOCUMENT') {
                    return documentOutput;
                }
                return 'Το έγγραφο δεν μπόρεσε να ανακτηθεί';
            }
            if (!(documentState === 'READY' || documentState === 'APPROVED')) {
                return '-';
            }
            if (
                (documentState === 'READY' || documentState === 'APPROVED') &&
                documentExpirationInDays === null
            ) {
                return 'Ισχύει';
            }
            if (
                (documentState === 'READY' || documentState === 'APPROVED') &&
                documentExpirationInDays > 0
            ) {
                return 'Ισχύει';
            }
            if (
                (documentState === 'READY' || documentState === 'APPROVED') &&
                documentExpirationInDays <= 0
            ) {
                return 'Έληξε';
            }
            return '-';
    }
}

function mapDocumentDuration(documentType, documentExpirationInDays) {
    switch (documentType) {
        case 'CONTRACT':
        case 'AKD_REPORT':
            return '-';
        default:
            if (documentExpirationInDays > 1) {
                return documentExpirationInDays + ' μέρες';
            }
            if (documentExpirationInDays === 1) {
                return '1 μέρα';
            }
            return '-';
    }
}

export function mapUserInfo(user) {
    let userInfo: UserInfo = {
        firstName: '',
        lastName: '',
        taxNumber: '',
        dateOfBirth: '',
        notaryRegId: '',
        roles: [],
        notaryUniqueId: '',
        individual: true,
    };

    userInfo.firstName = user.taxInfo.firstName;
    userInfo.lastName = user.taxInfo.lastName;
    userInfo.notaryRegId = '234-2343423-433';
    userInfo.taxNumber = user.taxInfo.taxNumber;
    userInfo.dateOfBirth = user.taxInfo.dateOfBirth;
    userInfo.roles = [USER_ROLE.NOTARY, USER_ROLE.CITIZEN];
    userInfo.notaryUniqueId = user.notaryUniqueId;
    if("individual" in user.taxInfo)
        userInfo.individual = user.taxInfo.individual;

    return userInfo;
}

export function createBackOfficerNotaryTaxLabel(
    notaryTaxNumber: string,
    notaryFirstName: string,
    notaryLastname: string
): string {
    let taxString = '';

    if (notaryTaxNumber === null) notaryTaxNumber = '';
    if (notaryFirstName === null) notaryFirstName = '';
    if (notaryLastname === null) notaryLastname = '';

    taxString = notaryTaxNumber + ' ' + notaryFirstName + ' ' + notaryLastname;

    return taxString;
}

export function createBackOfficerTaxLabel(
    contractingPeople: ContractingPeopleDetails[],
    capacity: string
): string {
    let taxNumbers = [];
    let taxString = '';

    contractingPeople
        .filter((person) => person.role == capacity)
        .map((person) => {
            const details: string[] = [];
            if (person.firstName) {
                details.push(person.firstName);
            }

            if (person.surname) {
                details.push(person.surname);
            }

            if (person.taxCode) {
                details.unshift(person.taxCode);
            }

            taxNumbers.push(details.join(' '));
        });
    taxString = taxNumbers.join('\n');
    return taxString;
}

export function taxNumbersToArray(contractingPeople, capacity) {
    let taxNumbers = [];
    let taxString = '';
    let personFullName = '';
    // console.log(contractingPeople, capacity);
    contractingPeople
        .filter((person) => person.role == capacity)
        .map((person) => {
            personFullName = person.involvedPartyDetails
                ? ' ' +
                  (person.involvedPartyDetails.firstName
                      ? person.involvedPartyDetails.firstName
                      : '') +
                  ' ' +
                  (person.involvedPartyDetails.lastName
                      ? person.involvedPartyDetails.lastName
                      : '')
                : '';

            if (person.vatId)
                taxNumbers.push(person.vatId + personFullName + '\n');
            else if (person.taxNumber)
                taxNumbers.push(person.taxNumber + personFullName + '\n');
        });
    taxString = taxNumbers.join(' ');
    return taxString;
}

export function namesToArray(contractingPeople, capacity) {
    let names = [];
    let namesString = '';
    contractingPeople
        .filter((person) => person.role == capacity)
        .map((person) =>
            names.push(person.involvedPartyDetails.fullname + '\n')
        );

    namesString = names.join(' ');
    return namesString;
}

export function getCitizenRole(taxNumber, payerTaxNumber, contractData) {
    var role;
    if (taxNumber === payerTaxNumber) role = 'PAYER';
    else role = getRoleFromTaxCode(taxNumber, contractData);

    return role;
}

export function hideKaekNumbers(role) {
    return role === 'BACKOFFICER';
}

export function hideLegalCheckAction(legalCheck) {
    return legalCheck === 'Σε Αναμονή';
}

export function hideCopyApplicationAction(legalCheck) {
  return legalCheck !== 'Απόρριψη';
}

export function hideTransferCertificationAction(cadApplStatus) {
    return cadApplStatus !== 'Οριστικά Καταχωρισμένη';
}

export function getRoleFromTaxCode(taxtNumber, contractData) {
    let role;

    contractData.involvedPartyList.forEach((person) => {
        if (taxtNumber === person.taxCode) {
            role = getBuyerSeller(person.role);
        }
    });
    return role;
}

export function getRegexAmountValue(value: string) {
    if (!value) {
        return value;
    }
    const regexPattern = /[.€]/g;
    const amount = parseFloat(
        value.replace(regexPattern, '').replace(',', '.')
    );

    return amount;
}

export function onlyTextRegex(value: string) {
    let regex = /^[A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώ ]+$/;
    return regex.test(value);
}

export function textAndNumbersRegex(value: string) {
    let regex = /^[A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώ0-9 ]+$/;
    return regex.test(value);
}

export function onlyDateRegex(value: string) {
    // Match dates either using YYYY - MM - DD or DD - MM - YYYY
    let regex = /(\d{2}\/\d{2}\/\d{4})|(\d{4}\/\d{2}\/\d{2})/;
    return regex.test(value);
}

export function onlyEuroAmountRegex(value: string) {
    value = value.replace('€', '').replace(' ', '');
    value = value.replace('.', '');
    value = value.replace(',', '.');

    let regex = /^\s*-?[1-9]\d*(\.\d{2,2})?\s*$/;
    return regex.test(value);
}

export function onlyDecimalNumberRegex(value: string) {
    let regex = /^\s*-?[1-9]\d*(\,\d{2,2})?\s*$/;
    return regex.test(value);
}

export function onlyNumbersRegex(value: string) {
    let regex = /^\d+$/;
    return regex.test(value);
}

export function transformValues(items) {
    // items.forEach((item) => {
    items.role = getBuyerSeller(items.role);
    // });
    return items;
}

export function getBuyerSeller(role: string) {
    let data = '';
    switch (role) {
        case 'BUYER':
            data = 'Αποκτών';
            break;
        case 'SELLER':
            data = 'Μεταβιβάζων';
            break;
        case 'Αποκτών':
            data = 'BUYER';
            break;
        case 'Μεταβιβάζων':
            data = 'SELLER';
            break;
    }
    return data;
}

export function getPropertyList(data, allProperties) {
    let properies = [];
    allProperties.forEach((prop) => {
        if (prop.cadOfficeId === data.cadOfficeId) {
            properies.push({
                kaek:
                    prop.kaekNumber +
                    '/' +
                    prop.verticalNumber +
                    '/' +
                    prop.horizontalNumber,
                propertyAddress: prop.address,
                propertyType: prop.description,
                taxNumber: prop.taxCode,
                citizenRole: getBuyerSeller(prop.role),
                //ownershipType: prop.ownershipTypeId,
                ownershipType: 'Πλήρης Κυριότητα',
                transferPercentage:
                    prop.ownershipNominator + '/' + prop.ownershipDenominator,
            });
        }
    });
    return properies;
}

export function mapNotaryApplications(httpResponse, router, dataService): DataTableConfig {
    let applications = [];
    let tableData: DataTableConfig;

    httpResponse.map((application) => {

        //ROW BUTTONS
        let actions = [];
        if(application.applicationType == TRANSER_TYPE.INHERITANCE){
          //check if involved properties is empty and add select button
          if(application.citizens.length > 0){

            const buyers = application.citizens.filter((row: any) => {
              return row.role === USER_CAPACITY.BUYER;
            });

            const sellers = application.citizens.filter((row: any) => {
              return row.role === USER_CAPACITY.SELLER;
            });

            actions.push({
              label: 'Επιλογή Ακινήτων',
              tip: '',
              actionCallback: () => {
                    dataService.onTransferTypeChange((application.applicationType > 0)?application.applicationType.toString():'1');
                    return router.navigate([
                        `/notary-transaction-acceptance-list/${application.appId}/${sellers[0].vatId}`,
                    ]);
              },
              classes: ['table-btn'],
              disabled: !(sellers.length > 0 && sellers[0].involvedProperties.length == 0)
            },);

          }
        }

        actions.push({
          label: 'Προβολή',
          tip: 'Προβολή/Επεξεργασία',
          actionCallback: () => {
              dataService.onTransferTypeChange((application.applicationType > 0)?application.applicationType.toString():'1');

              if (
                  application.status === 'SUBMITTED' ||
                  application.status === 'COMPLETED'
              )
                  return router.navigate([
                      '/notary-transaction-contract-cadastre/' +
                          application.appId,
                  ]);
              else if (
                  application.status === 'MANUALLY_SUBMITTED'
              )
                  return router.navigate([
                      '/notary-transaction-contract-cadastre-manual/' +
                          application.appId,
                  ]);
              else
                  return router.navigate([
                      '/notary-property-info/' +
                          application.appId,
                  ]);
          },
          classes: ['table-btn'],
          disabled:
              //mapApplicationStatus(application.status) === APPLICATION_STATUS.NEW,
              mapApplicationStatus('') === APPLICATION_STATUS.NEW,
        },);


        applications.push({
            requestNumber: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: application.appId,
            },
            applicationType:{
              type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
              value: capitalizeFirstLetter(dataService.getTranferTypeTextKey('typeSingular1', application.applicationType)),
            },
            cadRegistrationId: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: application.cadRegistrationId,
            },
            sellersAfm: {
              type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
              value: taxNumbersToArray(application.citizens, 'SELLER'),
            },
            buyersAfm: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: taxNumbersToArray(application.citizens, 'BUYER'),
            },

            submissionDate: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: dateFormat(application.creationDate),
            },
            documentValidity: {
                type: DATA_TABLE_CELL_TYPE.VALIDITY,
                value: mapDocumentValidity(application.documentValidity),
            },
            applicationStatus: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: dataService.formatStringWithTypeTexts(mapApplicationStatus(application.status), application.applicationType),
            },
            action: {
                type: DATA_TABLE_CELL_TYPE.ACTION,
                value: actions,
            },
        });
    });

    tableData = {
        headers: {
            requestNumber: 'Κωδικός Αιτήματος',
            applicationType: 'Είδος Πράξης',
            cadRegistrationId: 'Αριθμός Πρωτοκόλλου',
            // propertyAddress: 'Διεύθυνση Ακινήτου',
            sellersAfm: 'ΑΦΜ Μεταβιβαζόντων/Παρέχοντων',
            buyersAfm: 'ΑΦΜ Αποκτόντων',
            submissionDate: 'Ημερομηνία Υποβολής',
            documentValidity: 'Εγκυρότητα Εγγράφων',
            applicationStatus: 'Κατάσταση Αίτησης',
            action: 'Ενέργειες',
        },
        data: applications,
    };

    return tableData;
}

export function mapBackOfficerApplications(
    httpResponse,
    dataService: DataService
): DataTableConfig {
    let applications = [];
    let tableData: DataTableConfig;

    httpResponse.map((application) => {
        applications.push({
            requestNumber: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: application.applicationId,
            },
            // propertyAddress: {
            // type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
            // value: application.propertyAddress,
            // },
            notaryAfm: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: createBackOfficerNotaryTaxLabel(
                    application.notaryTaxCode,
                    application.notaryFirstName,
                    application.notarySurname
                ),
            },
            sellersAfm: {
              type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
              value: createBackOfficerTaxLabel(
                  application?.involvedPartyList ?? [],
                  'SELLER'
              ),
            },
            buyersAfm: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: createBackOfficerTaxLabel(
                    application?.involvedPartyList ?? [],
                    'BUYER'
                ),
            },
            submissionDate: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: dateFormat(application.lastUpdateDate),
            },
            kaekNumbers: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapKaekNumbers(application),
            },
            /*
            documentValidity: {
                type: DATA_TABLE_CELL_TYPE.VALIDITY,
                value: mapDocumentValidity(application.documentValidity),
            },*/
            applicationStatus: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: dataService.formatStringWithTypeTexts(mapApplicationStatus(application.applicationStatus), application.applicationType),
            },
            cadOfficeDescs: {
              type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
              value: mapCadOfficeDescs(application),
            },
            protocolNumbers: {
              type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
              value: mapProtocolNumbers(application),
            },
            paymentMethod: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapPaymentMethod(application),
            },
            paymentStatus: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: mapPaymentStatus(application),
            },
            // action: {
            //     type: DATA_TABLE_CELL_TYPE.ACTION,
            //     value: [
            //         {
            //             label: 'Προβολή',
            //             tip: 'Προβολή/Επεξεργασία',
            //             actionCallback: () => {
            //                 if (
            //                     application.status === 'SUBMITTED' ||
            //                     application.status === 'COMPLETED'
            //                 )
            //                     return router.navigate([
            //                         '/notary-transaction-contract-cadastre/' +
            //                             application.appId,
            //                     ]);
            //                 else if (
            //                     application.status === 'MANUALLY_SUBMITTED'
            //                 )
            //                     return router.navigate([
            //                         '/notary-transaction-contract-cadastre-manual/' +
            //                             application.appId,
            //                     ]);
            //                 else
            //                     return router.navigate([
            //                         '/notary-property-info/' +
            //                             application.appId,
            //                     ]);
            //             },
            //             classes: ['table-btn'],
            //             disabled:
            //                 mapApplicationStatus(application.status) ===
            //                 APPLICATION_STATUS.NEW,
            //         },
            //     ],
            // },
        });
    });

    tableData = {
        headers: {
            requestNumber: 'Κωδικός Αιτήματος',
            // propertyAddress: 'Διεύθυνση Ακινήτου',
            notaryAfm: 'ΑΦΜ Συμβολαιογράφου',
            buyersAfm: 'ΑΦΜ Αγοραστών',
            sellersAfm: 'ΑΦΜ Πωλητών',
            lastUpdateDate: 'Ημερομηνία Τελευταίας Ενημέρωσης',
            kaekNumbers: 'Κ.Α.Ε.Κ.',
            /*
          kaekNumbers: {
            type: hideKaekNumbers('ss') ? DATA_TABLE_CELL_TYPE.NOT_SHOWN : DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
            value: 'Κ.Α.Ε.Κ.'
          },
          */

            //documentValidity: 'Εγκυρότητα Εγγράφων',
            applicationStatus: 'Κατάσταση Αίτησης',
            cadOfficeDescs: 'Κτηματολογικό Γραφείο',
            protocolNumbers: 'Αριθμός Πρωτοκόλλου',
            paymentMethod: 'Μέθοδος Πληρωμής',
            paymentStatus: 'Κατάσταση Πληρωμής',
            // action: 'Ενέργεια',
        },
        data: applications,
    };
    return tableData;
}

function mapKaekNumbers(application) {
    if (!application.propertyList || !application.propertyList.length)
        return null;
    return Array.from(
        new Set(
            application.propertyList.map((item) => {
                return `${item.kaekNumber}/${item.verticalNumber}/${item.horizontalNumber}`;
            })
        )
    ).join('\n');
}
export function mapPaymentMethod(application) {
    if (!application.infoPerCadOfficeList) return null;
    if (application.infoPerCadOfficeList.length < 1) return null;
    return application.infoPerCadOfficeList
        .map((e) => {
            return (
                {
                    RF_PAYMENT: 'Κωδικός Πληρωμής RF',
                    CREDIT_CARD: 'Κάρτα',
                }[e.paymentMethod] ?? ''
            );
        })
        .join('\n');
}
export function mapApplications(httpResponse, router, dataService: DataService, userTaxNumber: string): DataTableConfig {
    let applications = [];
    let tableData: DataTableConfig;

    httpResponse.map((application) => {
        applications.push({
            requestNumber: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: application.appId,
            },
            applicationType: {
              type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
              value: capitalizeFirstLetter(dataService.getTranferTypeTextKey('typeSingular1', application.applicationType)),
            },
            // propertyAddress: {
            //     type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
            //     value: application.propertyAddress,
            // },
            capacity: {
                type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
                value: capitalizeFirstLetter(
                    application.role === USER_CAPACITY.BUYER
                        ? dataService.getTranferTypeTextKey('acquiringSingular1', application.applicationType)
                        : dataService.getTranferTypeTextKey('transferringSingular1', application.applicationType),
                )

            },
            notaryInfo: {
              type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
              value:
                  application.notaryTaxNumber +
                  '\n' +
                  application.notaryFullname,
            },
            submissionDate: {
              type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
              value: dateFormat(application.creationDate),
            },
            documentValidity: {
              type: DATA_TABLE_CELL_TYPE.VALIDITY,
              value: mapDocumentValidity(application.documentValidity),
            },
            applicationStatus: {
              type: DATA_TABLE_CELL_TYPE.PLAIN_TEXT,
              value: dataService.formatStringWithTypeTexts(mapApplicationStatus(application.status), application.applicationType),
            },
            action: {
                type: DATA_TABLE_CELL_TYPE.ACTION,
                value: [
                    {
                      label: mapCitizenApplicationStatus(application),
/*
                        label:
                            mapApplicationStatus(application.status) ===
                            APPLICATION_STATUS.NEW
                                ? 'Αποδοχή'
                                : 'Προβολή',
*/
                        tip:
                            mapApplicationStatus(application.status) ===
                            APPLICATION_STATUS.NEW
                                ? 'Αποδοχή/Επεξεργασία'
                                : 'Προβολή/Επεξεργασία',
                        actionCallback: () => {
                            if (applicationButtonDisabled(application, userTaxNumber)) {
                                return {};
                            }

                            dataService.onTransferTypeChange((application.applicationType).toString());

                            if (
                                application.status === 'SUBMITTED' ||
                                application.status === 'COMPLETED'
                            ) {
                                return router.navigate([
                                    '/citizen-transaction-contract-cadastre/' +
                                        application.appId,
                                ]);
                            }
                            if (
                                application.status !== 'NEW' &&
                                application.status !== 'SUBMITTED' &&
                                application.status !== 'COMPLETED'
                            ) {
                                return router.navigate([
                                    '/property-info/' + application.appId,
                                ]);
                            }
                            if (
                                application.role === 'SELLER' &&
                                mapCitizenAcceptanceStatus(
                                    application.acceptStatus
                                ) === TRANSACTION_INVITATION_STATUS.ACCEPTED &&
                                !application.propertySelectionIsCompleted
                            ) {
                                return router.navigate([
                                    '/citizen-transaction-acceptance-list/' +
                                        application.appId,
                                ]);
                            }
                            return router.navigate([
                                `/citizen-transaction-acceptance/${application.appId}/${application.role}`,
                            ]);
                        },
                        classes: ['table-btn'],
                        disabled: applicationButtonDisabled(application, userTaxNumber),
                    },
                ],
            },
        });
    });

    tableData = {
        headers: {
            requestNumber: 'Κωδικός Αιτήματος',
            // propertyAddress: 'Διεύθυνση Ακινήτου',
            applicationType: 'Είδος Πράξης',
            capacity: 'Ιδιότητα Πολίτη',
            notaryInfo: 'Στοιχεία Συμβολαιογράφου',
            submissionDate: 'Ημερομηνία Υποβολής',
            documentValidity: 'Εγκυρότητα Εγγράφων',
            applicationStatus: 'Κατάσταση Αίτησης',
            action: 'Ενέργεια',
        },
        data: applications,
    };

    return tableData;
}

function applicationButtonDisabled(application, taxNumber: string): boolean {
    if (application.status !== 'NEW') {
        if (
            (application.status === 'SUBMITTED' ||
                application.status === 'MANUALLY_SUBMITTED') &&
            application.role !== USER_CAPACITY.NOTARY
        )
            return true;
        else if (
            application.status === 'COMPLETED' &&
            application.role !== USER_CAPACITY.NOTARY &&
            application.role !== USER_CAPACITY.BUYER &&
            application.role !== USER_CAPACITY.SELLER
        )
            return true;
        else return false;
    }
    if (
        application.role === USER_CAPACITY.BUYER &&
        (!application.propertySelectionIsCompleted || (typeof application.representativesAccepted != undefined && application.representativesAccepted.includes(taxNumber)))//disable button if property selection is not complete or this representative has already accepted this app.
    ) {
        console.log(taxNumber, application.representativesAccepted);
        return true;
    }

    if (
        mapCitizenAcceptanceStatus(application.acceptStatus) ===
            TRANSACTION_INVITATION_STATUS.ACCEPTED &&
        application.propertySelectionIsCompleted
    ) {
        return true;
    }
    return false;
}

function mapPaymentStatus(application) {
  if (!application.infoPerCadOfficeList || !application.infoPerCadOfficeList.length)
      return null;
  return Array.from(
      new Set(
          application.infoPerCadOfficeList.map((item) => {
              return `${item.paymentStatus}`;
          })
      )
  ).join('\n');
}

function mapProtocolNumbers(application) {
  if (!application.infoPerCadOfficeList || !application.infoPerCadOfficeList.length)
      return null;
  return Array.from(
      new Set(
          application.infoPerCadOfficeList.map((item) => {
              return `${item.protocolNumber}`;
          })
      )
  ).join('\n');
}

function mapCadOfficeDescs(application) {
  if (!application.infoPerCadOfficeList || !application.infoPerCadOfficeList.length)
      return null;
  return Array.from(
      new Set(
          application.infoPerCadOfficeList.map((item) => {
              return `${item.cadOfficeDesc}`;
          })
      )
  ).join('\n');
}

export function mapDocumentValidity(response): DOCUMENT_VALIDITY | string {
    switch (response) {
        case false:
            return DOCUMENT_VALIDITY.INVALID;
        case true:
            return DOCUMENT_VALIDITY.VALID;
        case 'notChecked':
            return DOCUMENT_VALIDITY.NOT_CHECKED;
    }
}

export function mapCitizenApplicationStatus(application) {
  var applicationStatus;

  if (application.status !== 'NEW')
    applicationStatus = 'Προβολή';
  else if (application.status === 'NEW') {
    if (application.role === 'SELLER')
      applicationStatus = 'Αποδοχή';
    else if (application.role === 'BUYER') {
      if (application.sellersAccepted)
        applicationStatus = 'Αποδοχή';
      else
        applicationStatus = 'Αναμονή Πωλητή';
    }
    else
      applicationStatus = 'Προβολή';
  }

  return applicationStatus;
}

export function mapApplicationStatus(response): APPLICATION_STATUS {
    switch (response) {
        case 'NEW':
            return APPLICATION_STATUS.NEW;
        case 'ACTIVE':
            return APPLICATION_STATUS.ACTIVE;
        case 'REJECTED':
            return APPLICATION_STATUS.REJECTED;
        case 'REQUESTED_CANCELLATION':
            return APPLICATION_STATUS.REQUESTED_CANCELLATION;
        case 'CANCELLED':
            return APPLICATION_STATUS.CANCELLED;
        case 'SUBMITTED':
            return APPLICATION_STATUS.SUBMITTED;
        case 'MANUALLY_SUBMITTED':
            return APPLICATION_STATUS.MANUALLY_SUBMITTED;
        case 'COMPLETED':
            return APPLICATION_STATUS.COMPLETED;
        default:
            return null;
    }
}

function mapCitizenAcceptanceStatus(response): TRANSACTION_INVITATION_STATUS {
    switch (response) {
        case 'INITIAL':
            return TRANSACTION_INVITATION_STATUS.INITIAL;

        case 'ACCEPTED':
            return TRANSACTION_INVITATION_STATUS.ACCEPTED;
        case 'DECLINED':
            return TRANSACTION_INVITATION_STATUS.REJECTED;
        default:
            return null;
    }
}

export function mapUserCapacity(response): USER_CAPACITY {
    switch (response) {
        case 'BUYER':
            return USER_CAPACITY.BUYER;
        case 'SELLER':
            return USER_CAPACITY.SELLER;
        case 'NOTARY':
            return USER_CAPACITY.NOTARY;
    }
}

export function mapDocumentPublicSectorOwner(
    response
): DOCUMENT_PUBLIC_SECTOR_OWNER {
    switch (response) {
        case 'AFE_ISSUE_DOCUMENT':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.AADE;
        case 'DIAGRAM_REPORT':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.TEE;
        case 'AKD_REPORT':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.CADASTRE;
        case 'ENFIA_CERTIFICATE':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.AADE;
        case 'CIVIL_ENGINEER_CERTIFICATE':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.TEE;
        case 'COMPLETION_CERTIFICATE':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.TEE;
        case 'ENERGY_EFFICIENCY_CERTIFICATE':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.TEE;
        case 'FLOOR_PLANS':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.TEE;
        case 'INSURANCE_CERTIFICATE':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.EFKA;
        case 'CONTRACT':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.OTHER;
        case 'PROOF_OF_PAYMENT':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.AADE;
        case 'MUNICIPALITY_CERTIFICATE':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.OTHER;
        case 'TEEBUILD_DOCUMENTS':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.TEE;
        case 'CADASTRAL_DOCUMENTS':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.TEE;
        case 'GENERAL_GEMI_CERTIFICATE':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.GEMI;
        case 'GEMI_CERTIFICATE_OF_REPRESENTATION':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.GEMI;
        case 'DEATH_CERTIFICATE':
            return DOCUMENT_PUBLIC_SECTOR_OWNER.GOV;
        default:
            return null;
    }
}

export function mapDocumentTitle(response): DOCUMENT_TITLE {
    switch (response) {
        case 'AFE_ISSUE_DOCUMENT':
            return DOCUMENT_TITLE.AFE_ISSUE_DOCUMENT;
        case 'DIAGRAM_REPORT':
            return DOCUMENT_TITLE.DIAGRAM_REPORT;
        case 'AKD_REPORT':
            return DOCUMENT_TITLE.AKD_REPORT;
        case 'ENFIA_CERTIFICATE':
            return DOCUMENT_TITLE.ENFIA_CERTIFICATE;
        case 'CIVIL_ENGINEER_CERTIFICATE':
            return DOCUMENT_TITLE.CIVIL_ENGINEER_CERTIFICATE;
        case 'COMPLETION_CERTIFICATE':
            return DOCUMENT_TITLE.COMPLETION_CERTIFICATE;
        case 'ENERGY_EFFICIENCY_CERTIFICATE':
            return DOCUMENT_TITLE.ENERGY_EFFICIENCY_CERTIFICATE;
        case 'FLOOR_PLANS':
            return DOCUMENT_TITLE.FLOOR_PLANS;
        case 'INSURANCE_CERTIFICATE':
            return DOCUMENT_TITLE.INSURANCE_CERTIFICATE;
        case 'CONTRACT':
            return DOCUMENT_TITLE.CONTRACT;
        case 'PROOF_OF_PAYMENT':
            return DOCUMENT_TITLE.PROOF_OF_PAYMENT;
        case 'MUNICIPALITY_CERTIFICATE':
            return DOCUMENT_TITLE.MUNICIPALITY_CERTIFICATE;
        case 'TEEBUILD_DOCUMENTS':
            return DOCUMENT_TITLE.TEEBUILD_DOCUMENTS;
        case 'CADASTRAL_DOCUMENTS':
            return DOCUMENT_TITLE.CADASTRAL_DOCUMENTS;
        case 'GENERAL_GEMI_CERTIFICATE':
            return DOCUMENT_TITLE.GENERAL_GEMI_CERTIFICATE;
        case 'GEMI_CERTIFICATE_OF_REPRESENTATION':
            return DOCUMENT_TITLE.GEMI_CERTIFICATE_OF_REPRESENTATION;
        case 'DEATH_CERTIFICATE':
            return DOCUMENT_TITLE.DEATH_CERTIFICATE;
        default:
            return null;
    }
}
export function mapDocumentRevertLink(response): string {
    switch (response) {
        case 'CADASTRAL_DOCUMENTS':
            return 'Ανανέωση - Άντληση εκ νέου Εγγράφων από το ΤΕΕ';
        case 'TEEBUILD_DOCUMENTS':
            return 'Ανανέωση - Άντληση εκ νέου Εγγράφων από το ΤΕΕ';
        default:
            return null;
    }
}
export function mapDocumentRevertTypeLink(response): string {
    switch (response) {
        case 'CADASTRAL_DOCUMENTS':
            return 'CADASTRAL_DOCUMENTS';
        case 'TEEBUILD_DOCUMENTS':
            return 'TEEBUILD_DOCUMENTS';
        default:
            return null;
    }
}

export function mapNameInitials(response: any): UserNameInitials[] {
    const userNotifyInformation = response;
    return userNotifyInformation.map((user) => ({
        nameInitials: user.nameInitials,
        taxNumber: user.taxNumber,
        emailFound: user.emailFound,
        validAfm: user.validAfm,
        individual: user.individual,
        underage: user.underage,
    }));
}

export interface UserNameInitials {
    nameInitials: string;
    taxNumber: string;
    emailFound: boolean;
    validAfm: boolean;
    individual: boolean;
    underage: boolean;
}

export function isPdfFileType(type: string): boolean {
    return type.localeCompare('application/pdf') === 0;
}

export function isFileSizeValid(size: number, allowedSize: number): boolean {
    if (size > allowedSize) return false;
    else return true;
}

export function getTextFieldValue(data, fieldName, fieldType, role) {
    var colorStyle_RED = 'color: #FF0000';
    var colorStyle_GREEN = 'color: #00B050';
    var colorStyle_ORANGE = 'color: #ED7D31';
    var colorStyle_BLUE = 'color: #0070C0';

    if (fieldName === 'legalCheckStatus') {
        if (fieldType === 'text-value') {
            if (data.legalCheckStatus === 'Σε Αναμονή') {
                return data.legalCheckStatus;
            } else if (data.legalCheckStatus === 'Απόρριψη') {
                return '<b>' + data.legalCheckStatus + '</b>';
            } else if (data.legalCheckStatus === 'Μερική Αποδοχή') {
                return '<b>' + data.legalCheckStatus + '</b>';
            } else if (data.legalCheckStatus === 'Αποδοχή') {
                return '<b>' + data.legalCheckStatus + '</b>';
            } else {
                return '';
            }
        } else if (fieldType === 'text-style') {
            if (data.legalCheckStatus === 'Σε Αναμονή') {
                return '';
            } else if (data.legalCheckStatus === 'Απόρριψη') {
                return colorStyle_RED;
            } else if (data.legalCheckStatus === 'Μερική Αποδοχή') {
                return colorStyle_ORANGE;
            } else if (data.legalCheckStatus === 'Αποδοχή') {
                return colorStyle_GREEN;
            } else return '';
        }
    } else if (fieldName === 'paymentStatus') {
        if (fieldType === 'text-value') {
            if (data.paymentStatus === 'Υποβληθείσα') {
                return '<b>' + data.paymentStatus + '</b>';
            } else if (data.paymentStatus === 'Τιμολογηθείσα') {
              if (role === 'NOTARY' && data.paymentMethod === 'CREDIT_CARD')
              {
                return '<b>' + data.paymentStatus + ' (αναμονή εξόφλησης με Κάρτα από ' + data.payerName + ')</b>';
              }
              else {
                return '<b>' + data.paymentStatus + '</b>';
              }
            } else if (data.paymentStatus === 'Πληρωθείσα') {
                return '<b>' + data.paymentStatus + '</b>';
            } else return '';
        } else if (fieldType === 'text-style') {
            if (data.paymentStatus === 'Υποβληθείσα') {
                return '';
            } else if (data.paymentStatus === 'Τιμολογηθείσα') {
                return colorStyle_BLUE;
            } else if (data.paymentStatus === 'Πληρωθείσα') {
                return colorStyle_GREEN;
            } else return '';
        }
    } else if (fieldName === 'cadApplStatus') {
        if (fieldType === 'text-value') {
            if (data.cadApplStatus === 'Απόρριψη') {
                return '<b>' + data.cadApplStatus + '</b>';
            } else if (data.cadApplStatus === 'Εξαλειφθείσα') {
                return '<b>' + data.cadApplStatus + '</b>';
            } else return data.cadApplStatus;
        } else if (fieldType === 'text-style') {
            if (data.cadApplStatus === 'Απόρριψη') {
                return colorStyle_RED;
            } else if (data.cadApplStatus === 'Εξαλειφθείσα') {
                return colorStyle_GREEN;
            } else return '';
        }
    }
}

export function getPaymentButtonLabel(data) {
  if (data.paymentStatus === 'Τιμολογηθείσα' && data.paymentMethod === 'CREDIT_CARD') {
    return 'Πληρωμή με Κάρτα <i class="fa fa-credit-card"></i>';
  } else if (data.paymentStatus === 'Τιμολογηθείσα') {
    return 'Έντυπο Οφειλής';
  } else if (data.paymentStatus === 'Πληρωθείσα') {
    return 'Απόδειξη Πληρωμής';
  } else {
    return 'Τιμολογηθείσα';
  }
}

export const isTaxNumberBackOfficer = (taxNumber: string) => {
    return getBackOfficersTaxNumbers().includes(taxNumber);
};

export function getBackOfficersTaxNumbers() {
    const backOfficersTaxNumbers = ['1326917440', '104179850'];
    //const backOfficersTaxNumbers = ['', ''];
    return backOfficersTaxNumbers;
}

export function capitalizeFirstLetter(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}
